<script lang="ts">
  import { Button } from "$lib/components/ui/button"
  import { MoveRight } from "lucide-svelte"
  import { getRequirement } from "../../utils"
  import { getContext } from "svelte"
  import { t, getCurrentLanguage } from "$lib/utils/i18n"

  interface Props {
    action: any
    processAction: (action: any) => void
  }

  let { action, processAction }: Props = $props()

  const language = getCurrentLanguage()

  const entries = getRequirement(action, "Entries") || 0

  const ACTIONS_JUST_USERNAME = [
    "Follow on Threads",
    "Visit Profile on Threads",
  ]

  const ACTIONS_FULL_URL = [
    "View a Post on Threads",
    "Tag friends on Threads Post",
  ]

  const customUrl = getRequirement(action, "Threads Url")

  // If inAppBrowser is true, we need to open the link
  // in the app to trigger Instagram bottom navigation bar
  const inAppBrowser = getContext("inAppBrowser")

  let description = $derived(
    (action.selectedAction || action)?.requirements.find(
      (r) => r.name === "Instructions",
    )?.value,
  )

  let buttonText = $derived(
    (action.selectedAction || action)?.requirements.find(
      (r) => r.name === "Button Text",
    )?.value,
  )

  // Tämä toiminto on 3 arpaa arvoinen

  let entryPluralized = $derived(
    t("widget_action_entries", {
      count: Number(entries),
    }),
  )
</script>

<div class="bg-white rounded-lg p-4 shadow-lg">
  <div class="mb-4">
    {#if description}
      <div class="description-content text-black mb-10">
        {@html description}
      </div>
    {:else}
      <h4 class="text-sm font-medium mb-2">
        {t("widget_action_worth", {
          count: entries,
          entries: entryPluralized,
        })}
      </h4>
    {/if}
  </div>

  <Button
    variant="default"
    class="w-full bg-black text-white hover:bg-gray-800 flex items-center justify-center gap-2"
    onclick={() => {
      const actionName = (action.selectedAction || action.actions)?.name
      if (ACTIONS_JUST_USERNAME.includes(actionName)) {
        const username = getRequirement(action, "Username")
        if (inAppBrowser) {
          window.open(`https://www.threads.com/@${username}`)
        } else {
          window.open(`https://www.threads.com/@${username}`, "_blank")
        }
      } else if (ACTIONS_FULL_URL.includes(actionName)) {
        const url = getRequirement(action, "URL")
        if (inAppBrowser) {
          window.open(url)
        } else {
          window.open(url, "_blank")
        }
      } else {
        if (customUrl) {
          window.open(customUrl, "_blank")
        } else {
          window.open("https://www.threads.com", "_blank")
        }
      }
      processAction(action)
    }}
  >
    {#if (action.selectedAction || action.actions)?.name === "Custom Action"}
      {buttonText}
    {:else if language === "en"}
      {(action.selectedAction || action.actions)?.name}
    {:else}
      {(action.selectedAction || action.actions)?.translations?.[language]
        ?.name}
    {/if}
    <MoveRight />
  </Button>
</div>
